<script>
	import axios from 'axios';
	import mixin from '../../mixin';

	export default {
		mixins: [mixin],
		props: {
			idFromUrl: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				claimDetailsData: {},
			};
		},
		async mounted() {
			await this.fetchData(this.idFromUrl);
		},
		methods: {
			async fetchData(idFromURL) {
				try {
					const response = await axios.get(
						`/api/dossiers/${idFromURL}/vorderinggegevens`
					);
					if (response ?? response.data) {
						this.claimDetailsData = response.data;
					} else {
						console.error('Invalid data received:', response);
					}
				} catch (error) {
					console.error('Error fetching data:', error);
				}
			},
		},
	};
</script>

<template>
	<div class="claim-details mt-3 pt-3 content">
		<template v-if="claimDetailsData">
			<div class="columns">
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsSubject') }}</p>
						<p>{{ checkValue(claimDetailsData.dossier_naam) }}</p>
					</div>
				</div>
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsOpeningdatetime') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.ingangsdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsCaseNumber') }}</p>
						<p>{{ checkValue(parseDossierNr(claimDetailsData.dossier_nr)) }}</p>
					</div>
				</div>
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDateOfSummons') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.dagvaardingdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsReference') }}</p>
						<p>{{ checkValue(claimDetailsData.referentie_nr) }}</p>
					</div>
				</div>
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDateOfHearing') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.eerste_zittingsdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsCustomer') }}</p>
						<p>{{ checkValue(claimDetailsData.debiteur_naam) }}</p>
					</div>
				</div>
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDateTitle') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.vonnisdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsPlaintiff') }}</p>
						<p>{{ checkValue(claimDetailsData.eiser_naam) }}</p>
					</div>
				</div>
				<div class="column">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDateOfService') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.betekeningdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDateClosed') }}</p>
						<p>{{ checkValue(toDateStr(claimDetailsData.afsluitdatum)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsPhase') }}</p>
						<p>{{ checkValue(claimDetailsData.fase_label) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsStatus') }}</p>
						<p>{{ checkValue(this.capitalize(claimDetailsData.lopend_afgesloten)) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsStatusCase') }}</p>
						<p>{{ checkValue(claimDetailsData.status_extern_label) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsSettlementReason') }}</p>
						<p>{{ checkValue(claimDetailsData.afsluit_oms) }}</p>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6 is-offset-6">
					<div class="claim-details__item">
						<p>{{ $store.getters.getRightText('dossierdetailLabelClaimDetailsDurationInDays') }}</p>
						<p>{{ checkValue(claimDetailsData.looptijd) }}</p>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="box">
				{{ $store.getters.getRightText('dossierdetailLabelNoResults') }}
			</div>
		</template>
	</div>
</template>
